module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _c('a', {
    attrs: {
      "id": "toc"
    }
  }, [_c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br'), _c('br')])]), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_cop_r1"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_fm1_r1"
    }
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_itr_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1"
    }
  }, [_vm._v("CHAPTER ONE -  The Basics")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h1"
    }
  }, [_vm._v("Request for Approval")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h2"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h3"
    }
  }, [_vm._v("Reply to a Request for Approval")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h4"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h5"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h6"
    }
  }, [_vm._v("Request for Information")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h7"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h8"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h9"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h10"
    }
  }, [_vm._v("Reply to a Request for Information")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h11"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c01_r1#h12"
    }
  }, [_vm._v("Advice")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWO -  Sharing Information")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Your Information")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover for Attached Document")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary of a Conference Call")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Announcement of a Meeting")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary of a Meeting")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confirmation of an Oral Agreement")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c02_r1#h18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advice")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE -  Delicate Situations")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Request for Special Treatment")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problem-Solving Suggestion")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reassigning Fault")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retroactive Correction")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Misplaced Document")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal to Participate")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apology for Inappropriate Behavior")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c03_r1#h18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR -  Vendors and Suppliers")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confirming an Order")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Call for Bids")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Errors in Invoicing")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Requesting Credit")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Refusal of Credit")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Change of Terms")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c04_r1#h20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advice")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE -  Sales and Marketing")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invitation to an Open House")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Announcing a New Sales Rep")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pitch for Appointment")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Employee Discounts")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Targeted Product Launch")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Launch Announcement")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marketing Query")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c05_r1#h20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX -  Working as a Team")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Congratulations")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Change in Policy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Explaining a Procedure")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Encouraging Teamwork")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Employee Training")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Company Reception")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c06_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advice")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN -  Employee Issues")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Time for Promotion")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Away From My Desk")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Employee Transfer Request")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resignation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problem in the Office")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thank You for the Bonus")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c07_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT -  Leadership")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Request for Cooperation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Handling Rumors")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Correcting a Colleague")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reprimanding a Subordinate")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advice")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reference")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motivating an Employee")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c08_r1#h20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advice")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE -  Deals and Contracts")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary of a Deal")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analysis of a Contract")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Technical Concepts Explained")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advice on Compliance")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Changes in a Draft")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c09_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN -  Run It Past Legal")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legal Opinion")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legal Analysis")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legal Research")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Netiquette")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Status of Litigation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outcome of Litigation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c10_r1#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN -  On a Personal Note")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advice")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consoling Coworkers")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Options")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Expressing Sympathy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advice")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advice")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal Congratulations")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal Thanks")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_c11_r1#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('div', [_c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Briefings")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_bib_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/bano_9781601638632_oeb_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f256836a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bano_9781601638632_oeb_toc_r1.vue
// module id = 57
// module chunks = 0